<template>
    <div class="map">
        <!-- <div class="serach_wrapper">
				<el-input v-model="keyword" placeholder="请输入姓名" style="width: 120px; margin-right: 12px"></el-input>
				<el-button type="primary">搜索</el-button>
			</div> -->
        <div id="container" style="width: 100%; height: 100%"></div>
        <BusinessDialog
            ref="business"
            v-if="showShangjia"
            :shangjiaId="shangjiaId"
            @setBuiness="setBuiness"
        ></BusinessDialog>
        <TeamDialog
            ref="teamDialog"
            v-if="showTeam"
            :teamId="teamId"
            @setTeam="setTeam"
        ></TeamDialog>
        <ZhyzhDialog
            ref="zhiyuanzhe"
            v-if="showZhiyuanzhe"
            :zhiyuanzheId="zhiyuanzheId"
            @setShow="setShow"
        ></ZhyzhDialog>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import BusinessDialog from "./businessDialog.vue"
import TeamDialog from "./teamDialog.vue"
import ZhyzhDialog from "./zhyzhDialog.vue"
export default {
    components: {
        BusinessDialog,
        TeamDialog,
        ZhyzhDialog,
    },
    data() {
        return {
            teamId: "",
            zhiyuanzheId: "",
            shangjiaId: "",
            showTeam: false,
            showZhiyuanzhe: false,
            showShangjia: false,
            keyword: "",
            map: null,
            markers: [],
            findList: [],
        }
    },
    async mounted() {
        this.getList()
        await this.loadMap()
    },
    methods: {
        loadMap() {
            //地图加载
            return new Promise((resolve, reject) => {
                this.map = new AMap.Map("container", {
                    resizeEnable: true,
                    mapStyle: "amap://styles/darkblue",
                    zoom: 9,
                })
                resolve()
            })
        },
        renderMapMarker(data) {
            let self = this
            data.forEach((item) => {
                let marker = new AMap.Marker({
                    position: [item.longitude, item.latitude],
                    icon: item.tubiao,
                })
                // var baodao = new AMap.Marker({
                // 	position: [item.longitude, item.latitude - 0.1],
                // 	content: `<div style='color:#fff;width:50px';>${item.name}</div>`,
                // 	offset: new AMap.Pixel(0, 0),
                // 	map: this.map
                // });
                self.markers.push(marker)
                marker.on("mouseover", (e) => {
                    marker.setTitle(item.name)
                })
                marker.on("click", (e) => {
                    if (item.typeId == "shangjia") {
                        this.shangjiaId = item.id
                        this.showShangjia = true
                        self.$refs.business.dialogVisible = true
                    }
                    if (item.typeId == "tuandui") {
                        this.teamId = item.id
                        this.showTeam = true
                        this.$nextTick(function () {
                            this.$refs.teamDialog.examineDialog = true
                        })
                    }
                    if (item.typeId == "zhiyuanzhe") {
                        this.zhiyuanzheId = item.id
                        this.showZhiyuanzhe = true
                        this.$nextTick(function () {
                            this.$refs.zhiyuanzhe.dialogVisible = true
                        })
                    }
                })
            })
            self.map.add(self.markers)
            self.map.setFitView(self.markers)
            self.map.setZoom(4)
        },
        setShow() {
            this.showZhiyuanzhe = false
        },
        setBuiness() {
            this.showShangjia = false
        },
        setTeam() {
            this.showTeam = false
        },
        getList() {
            request({
                url: "/sqyl/bigData/info/findMap",
                method: "POST",
                data: {},
            }).then((res) => {
                if (res.code == 200) {
                    res.content.corporationRecruitments.forEach(
                        (item, index) => {
                            item.tubiao = require("../../assets/img/td-icon.png")
                            item.typeId = "tuandui"
                        }
                    )
                    this.renderMapMarker(res.content.corporationRecruitments)
                    res.content.unitInformations.forEach((item, index) => {
                        item.tubiao = require("../../assets/img/shj-icon.png")
                        item.typeId = "shangjia"
                    })
                    this.renderMapMarker(res.content.unitInformations)
                    res.content.volunteerArchiveList.forEach((item, index) => {
                        item.tubiao = require("../../assets/img/zhyzh-icon.png")
                        item.typeId = "zhiyuanzhe"
                        if (!item.latitude && !item.longitude) {
                            res.content.volunteerArchiveList.splice(index, 1)
                        }
                    })
                    this.renderMapMarker(res.content.volunteerArchiveList)
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
            })
        },
    },
}
</script>

<style lang="less" scoped>
.taiwan {
    width: 50px;
    color: red;
    background-color: rgba(255, 0, 0, 0.1);
}
</style>
